import * as style from './styles';

export function SkeletonHeader() {
  return (
    <div className={style.Container()}>
      <div className={style.Title()} />
    </div>
  );
}
